exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".disabled[data-v-43a1fb34] {\n  background-color: gray;\n}\n.round[data-v-43a1fb34] {\n  border-radius: 24px;\n}\n.active_office-color[data-v-43a1fb34] {\n  background-color: #D3A78F;\n}\n.button-full[data-v-43a1fb34] {\n  min-width: 250px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n}\n.button-full.activeColor[data-v-43a1fb34] {\n  background-color: #f0047f;\n}\n.button-full.activeColor.disabled[data-v-43a1fb34] {\n  background-color: gray;\n}\n", ""]);

// exports
